<template>
  <div>
    <slot name="top"></slot>
    <div class="default-layout">
      <!-- this is the left side of the screen -->
      <div class="left">
        <slot name="left">
          <left-side-bar-bottom/>
        </slot>
      </div>

      <div class="center ">
        <slot name="center"></slot>
      </div>

      <div class="right" v-if="$slots.right">
        <slot name="right"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import LeftSideBarBottom from "@/components/LayoutPartials/LeftSideBarBottom";

export default {
  name: "DefaultLayout",
  components: {LeftSideBarBottom}
}
</script>

<style lang="scss" scoped>

.default-layout {
  display: flex;
  align-content: start;

  > .left {
    flex: 0 0 250px;
    min-width: 0;
    margin-right: 30px;
  }

  > .center {
    flex-grow: 1;
    min-width: 0;
  }

  > .right {
    flex: 0 0 250px;
    min-width: 0;
    margin-left: 30px;
  }

  @include down(1200) {
    > .left {
      margin-right: 1%;
      flex: 0 0 20%;
    }
    > .right {
      margin-left: 1%;
      flex: 0 0 20%;
    }
  }

  @include down(900) {
    > .right {
      display: none;
    }
    > .left {
      flex: 0 0 25%;
    }
  }
  @include down(768) {
    > .left {
      display: none;
    }
  }
}
</style>
